import { DESTINATION_TYPES } from '../../../constants';
import type { AddressFormSectionClientProps, DestinationType } from '../../../types';
import type { CartAddressData } from 'services';
import { getDestinationTypeFromShippingCategory } from './getDestinationTypeFromShippingCategory';

/** Selects the saved pickup-point or shipping address matching the active destination type. */
export function getSavedAddressForDestinationType(
  destinationType: DestinationType,
  pickupPointAddress: AddressFormSectionClientProps['pickupPointAddress'],
  shippingAddress: AddressFormSectionClientProps['shippingAddress']
): CartAddressData | undefined {
  if (destinationType === DESTINATION_TYPES.PICKUP_POINT) {
    return pickupPointAddress;
  }

  const shippingDestinationType = getDestinationTypeFromShippingCategory(shippingAddress?.category);

  return shippingDestinationType === destinationType ? shippingAddress : undefined;
}